import { ListItem, ListItemLabel } from 'baseui/list';
import { memo, useRef } from 'react';
import { useRecoilState } from 'recoil';
import { useHover } from 'usehooks-ts';
import { useStyles } from '../../../hooks/useStyles';
import { selectedEventSettingState } from '../../../storage/eventSettings';
import { InternalEventSetting } from '../../../types/eventSetting';

type Props = {
  eventSetting: InternalEventSetting;
};

function EventItem({ eventSetting }: Readonly<Props>) {
  const { theme } = useStyles();
  const [selectedEvent, setSelectedEvent] = useRecoilState(selectedEventSettingState);
  const internalId = eventSetting.internalId;
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);
  const isSelected = selectedEvent === internalId;

  const onSelectEvent = () => {
    if (isSelected) setSelectedEvent(undefined);
    else setSelectedEvent(internalId);
  };

  return (
    <span ref={hoverRef}>
      <ListItem
        overrides={{
          Root: {
            props: {
              onClick: onSelectEvent,
            },
            style: {
              cursor: 'pointer',
              backgroundColor: isSelected
                ? theme.colors.backgroundTertiary
                : isHover
                  ? theme.colors.backgroundSecondary
                  : undefined,
              boxSizing: 'border-box',
              borderRight: `5px solid ${isSelected ? theme.colors.backgroundInversePrimary : 'transparent'}`,
            },
          },
          Content: {
            style: {
              marginLeft: 0,
              paddingLeft: theme.sizing.scale600,
              minHeight: '30px',
              borderBottomColor: 'transparent',
            },
          },
        }}
      >
        <ListItemLabel
          overrides={{
            LabelContent: {
              style: { ...theme.typography.LabelSmall },
            },
          }}
        >
          {eventSetting.notificationDescription || '-'}
        </ListItemLabel>
      </ListItem>
    </span>
  );
}

export default memo(EventItem);
